import {createRouter, createWebHashHistory} from "vue-router";

import store from "./store";
import Login from "@/views/Login";
import Affectations from "@/views/Crud/Affectations";
import AlarmsView from "@/views/AlarmsView";
import AlarmCodes from "@/views/Crud/AlarmCodes";
import PerformanceRatioSolarPanel from "@/views/Crud/PerformanceRatioSolarPanel";
import Analytics from "@/views/AnalyticsView";
import Automatons from "@/views/AutomatonsView";
import Consumables from "@/views/Crud/Consumables";
import ExternalRepairs from "@/views/Crud/ExternalRepairs";
import Help from "@/views/Help";
import Home from "@/views/Home";
import InternalRepairs from "@/views/Crud/InternalRepairs";
import InterventionReportEdition from "@/views/InterventionReportEdition";
import InterventionReportView from "@/views/InterventionReportView";
import PreventiveMaintenances from "@/views/Crud/PreventiveMaintenances";
import LimitationView from "@/views/LimitationView";
import MaintenanceView from "@/views/MaintenanceView";
import PartEdition from "@/views/PartEdition";
import PartView from "@/views/PartView";
import PartCategories from "@/views/Crud/PartCategories";
import Places from "@/views/Crud/Places";
import PowerStations from "@/views/Crud/PowerStations";
import ProdAvailability from "@/views/ProdAvailabilityView";
import ProdAvailabilityMonth from "@/views/ProdAvailabilityMonthView";
import Producers from "@/views/Crud/Producers";
import ProducerTypes from "@/views/Crud/ProducerTypes";
import Purchases from "@/views/Crud/Purchases";
import PurchaseLines from "@/views/Crud/PurchaseLines";
import PurchaseView from "@/views/PurchaseView";
import SolarProduction from "@/views/SolarProduction";
import SolarProducerView from "@/views/SolarProducerView";
import BatteryView from "@/views/BatteryView";
import BatteryHistoryView from "@/views/BatteryHistoryView";
import SpotPriceContracts from "@/views/Crud/SpotPriceContracts";
import WindProduction from "@/views/WindProduction";
import WindProducerView from "@/views/WindProducerView";
import WindPowerStationView from "@/views/WindPowerStationView";
import Scheduler from "@/views/Scheduler";
import StockParts from "@/views/Crud/StockParts";
import Stockages from "@/views/Crud/Stockages";
import Suppliers from "@/views/Crud/Suppliers";
import Telemetry from "@/views/Telemetry";
import TelemetryBoard from "@/views/TelemetryBoard";
import TelemetryGeneric from "@/views/TelemetryGeneric";
import TelemetryNamibie from "@/views/TelemetryNamibie";
import Todos from "@/views/Crud/Todos";
import TodoView from "@/views/TodoView";
import Units from "@/views/Crud/Units";
import VerifMachine from "@/views/Crud/VerifMachine";
import User from "@/views/User";
import UnitView from "@/views/UnitView";
import Logout from "@/views/Logout";
import MachineSolarProducer from "@/views/MachineSolarProducer.vue";
import TelemetryChartSolar from "./components/TelemetryChartSolar.vue";
import TelemetryChartSolarGrafana from "./components/TelemetryChartSolarGrafana.vue";
import SgeView from "@/views/SgeView.vue";
import { isSgeUser } from "@/services/sge";
import DashboardTV1 from "@/views/DashboardTV1.vue";
import DashboardTV2 from "@/views/DashboardTV2.vue";
import DashboardTV3 from "@/views/DashboardTV3.vue";
import DashboardTV4 from "@/views/DashboardTV4.vue";
import DashboardTV5 from "@/views/DashboardTV5.vue";
const EnedisInjection = () => import("@/views/EnedisInjectionView.vue");

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      showNav: false
    }
  },
  {
    path: "",
    name: "home",
    component: Home,
    meta: {
      title: "Accueil",
      requiresAuth: true
    }
  },
  {
    path: "/solar_production",
    name: "solar_production",
    component: SolarProduction,
    meta: {
      title: "Production solaire",
      requiresAuth: true
    }
  },
  {
    path: "/solar_producer",
    name: "solar_producer",
    component: SolarProducerView,
    meta: {
      title: "Producteur solaire",
      requiresAuth: true
    }
  },
  {
    path: "/batteries",
    name: "batteries",
    component: BatteryView,
    meta: {
      title: "Batteries",
      requiresAuth: true
    }
  },
  {
    path: "/battery_history",
    name: "battery_history",
    component: BatteryHistoryView,
    meta: {
      title: "Historique batterie",
      requiresAuth: true
    }
  },
  {
    path: "/wind_production",
    name: "wind_production",
    component: WindProduction,
    meta: {
      title: "Production éolienne",
      requiresAuth: true
    }
  },
  {
    path: "/wind_producer",
    name: "wind_producer",
    component: WindProducerView,
    meta: {
      title: "Producteur éolien",
      requiresAuth: true
    }
  },
  {
    path: "/wind_power_station",
    name: "wind_power_station",
    component: WindPowerStationView,
    meta: {
      title: "Centrale éolienne",
      requiresAuth: true
    }
  },
  {
    path: "/sge",
    name: "sge",
    component: SgeView,
    meta: {
      title: "SGE",
      requiresAuth: true,
      requiresSge: true,
    }
  },
  {
    path: "/machine_solar_producer",
    name: "machine_solar_producer_view",
    component: MachineSolarProducer,
    meta: {
      title: "Machine Solar Producer view",
      requiresAuth: true
    }
  },
  {
    path: "/scheduler/:year?/:week?",
    name: "scheduler",
    component: Scheduler,
    props: true,
    meta: {
      title: "Scheduler",
      requiresAuth: true
    }
  },
  {
    path: "/telemetry",
    name: "telemetry",
    component: Telemetry,
    meta: {
      title: "Telemetry",
      requiresAuth: true
    }
  },
  {
    path: "/telemetry_view",
    name: "telemetry_view",
    component: TelemetryBoard,
    meta: {
      title: "TelemetryBoard",
      requiresAuth: true,
      showNav: false
    }
  },
  {
    path: "/telemetry_generic",
    name: "telemetry_generic",
    component: TelemetryGeneric,
    meta: {
      title: "Telemetry",
      requiresAuth: true,
      showNav: false
    }
  },
  {
    path: "/dashboardTV1",
    name: "dashboardTV1",
    component: DashboardTV1,
    meta: {
      title: "Dashboard TV1",
      requiresAuth: false,
      showNav: false
    }
  },  
  {
    path: "/dashboardTV2",
    name: "dashboardTV2",
    component: DashboardTV2,
    meta: {
      title: "Dashboard TV2",
      requiresAuth: false,
      showNav: false
    }
  },  
  {
    path: "/dashboardTV3",
    name: "dashboardTV3",
    component: DashboardTV3,
    meta: {
      title: "Dashboard TV3",
      requiresAuth: false,
      showNav: false
    }
  },  
  {
    path: "/dashboardTV4",
    name: "dashboardTV4",
    component: DashboardTV4,
    meta: {
      title: "Dashboard TV4",
      requiresAuth: false,
      showNav: false
    }
  },  
  {
    path: "/dashboardTV5",
    name: "dashboardTV5",
    component: DashboardTV5,
    meta: {
      title: "Dashboard TV5",
      requiresAuth: false,
      showNav: false
    }
  },
  {
    path: "/telemetry_solar_grafana",
    name: "telemetry_solar_grafan",
    component: TelemetryChartSolarGrafana,
    meta: {
      title: "Telemetry Solar Grafana",
      requiresAuth: true,
      showNav: false
    }
  },
  {
    path: "/telemetry_solar",
    name: "telemetry_solar",
    component: TelemetryChartSolar,
    meta: {
      title: "Telemetry Solar",
      requiresAuth: true,
      showNav: false
    }
  },
  {
    path: "/telemetry_namibie",
    name: "telemetry_namibie",
    component: TelemetryNamibie,
    meta: {
      title: "Telemetry",
      requiresAuth: true,
      showNav: false
    }
  },
  {
    path: "/automaton",
    name: "automaton",
    component: Automatons,
    meta: {
      title: "Automaton",
      requiresAuth: true
    }
  },
  {
    path: "/part_view",
    name: "part_view",
    component: PartView,
    meta: {
      title: "PartView",
      requiresAuth: true
    }
  },
  {
    path: "/part_edition/:part?",
    name: "part_edition",
    component: PartEdition,
    props: true,
    meta: {
      title: "PartEdition",
      requiresAuth: true
    }
  },
  {
    path: "/intervention_reports",
    name: "intervention_reports",
    component: InterventionReportView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/intervention_reports/edition/:pk?",
    name: "intervention_reports_edition",
    component: InterventionReportEdition,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/limitations",
    name: "limitation_view",
    component: LimitationView,
    props: false,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/todo_view",
    name: "todo_view",
    component: TodoView,
    meta: {
      title: "TodoView",
      requiresAuth: true
    }
  },
  {
    path: "/purchase_view",
    name: "purchase_view",
    component: PurchaseView,
    meta: {
      title: "PurchaseView",
      requiresAuth: true
    }
  },
  {
    path: "/maintenance_view",
    name: "maintenance_view",
    component: MaintenanceView,
    meta: {
      title: "MaintenanceView",
      requiresAuth: true,
    }
  },
  {
    path: "/alarm_view",
    name: "alarms",
    component: AlarmsView,
    meta: {
      title: "Alarms",
      requiresAuth: true
    }
  },
  {
    path: "/analytics",
    name: "analytics",
    component: Analytics,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/part_categories",
    name: "part_categories",
    component: PartCategories,
    meta: {
      title: "PartCategories",
      requiresAuth: true,
      requiresStaff: true,
    }
  },
  {
    path: "/units",
    name: "units",
    component: Units,
    meta: {
      title: "Units",
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/verif_machine",
    name: "verif_machine",
    component: VerifMachine,
    meta: {
      title: "VerifMachines",
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/consumables",
    name: "consumables",
    component: Consumables,
    meta: {
      title: "Consumables",
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/stock_parts",
    name: "stock_parts",
    component: StockParts,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/suppliers",
    name: "suppliers",
    component: Suppliers,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/stockages",
    name: "stockages",
    component: Stockages,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/external_repairs",
    name: "external_repairs",
    component: ExternalRepairs,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/internal_repairs",
    name: "internal_repairs",
    component: InternalRepairs,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/affectations",
    name: "affectations",
    component: Affectations,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/prod_availability",
    name: "prod_availability",
    component: ProdAvailability,
    meta: {
      requiresAuth: false,
      requiresStaff: true
    }
  },
  {
    path: "/prod_availability_month",
    name: "prod_availability_month",
    component: ProdAvailabilityMonth,
    meta: {
      requiresAuth: false,
      requiresStaff: true
    }
  },
  {
    path: "/enedis_injection",
    name: "enedis_injection",
    component: EnedisInjection,
    meta: {
      requiresAuth: false,
      requiresStaff: true
    }
  },
  {
    path: "/producers",
    name: "producers",
    component: Producers,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/producer_types",
    name: "producer_types",
    component: ProducerTypes,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/power_stations",
    name: "power_stations",
    component: PowerStations,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/places",
    name: "places",
    component: Places,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/purchases",
    name: "purchases",
    component: Purchases,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/purchase_lines",
    name: "purchase_lines",
    component: PurchaseLines,
    meta: {
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/todos",
    name: "todos",
    component: Todos,
    meta: {
      title: "Todos",
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/preventive_maintenances",
    name: "preventive_maintenances",
    component: PreventiveMaintenances,
    meta: {
      title: "PreventiveMaintenances",
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/alarm_codes",
    name: "alarm_codes",
    component: AlarmCodes,
    meta: {
      title: "AlarmCodes",
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/performance_ratio_solar_panel",
    name: "performance_ratio_solar_panel",
    component: PerformanceRatioSolarPanel,
    meta: {
      title: "PerformanceRatioSolarPanel",
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/spot_price_contracts",
    name: "spot_price_contracts",
    component: SpotPriceContracts,
    meta: {
      title: "SpotPriceContracts",
      requiresAuth: true,
      requiresStaff: true
    }
  },
  {
    path: "/help",
    name: "help",
    component: Help,
    meta: {
      title: "Help",
      requiresAuth: true
    }
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout
  },
  {
    path: "/user",
    name: "user",
    component: User
  },
  {
    path: "/unit",
    name: "unit",
    component: UnitView,
    props: true,
    meta: {
      title: "UnitView",
      requiresAuth: true
    }
  },
  {
    path: "/conduite_france",
    name: "conduite_france",
    beforeEnter() {
      const url =
        "https://docs.google.com/spreadsheets/d/1kH-qBsd6bicJSGY8dbnZlfydfy4YdREpLJV8rPfuWfw/edit?usp=sharing";
      window.open(url, "_blank");
    }
  },
  {
    path: "/procedures",
    name: "procedures",
    beforeEnter() {
      const url =
        "https://drive.google.com/drive/folders/18OyNqm-uqvdEp_ejGTEKkNVuuwtAurmJ";
      window.open(url, "_blank");
    },
  },
  {
    path: "/inspections",
    name: "inspections",
    beforeEnter() {
      const url =
        "https://drive.google.com/drive/folders/14O6yT1uy-utoCRe04l9-XAv_SUUHRqaF";
      window.open(url, "_blank");
    },
  },
  {
    path: "/travaux",
    name: "travaux",
    beforeEnter() {
      const url =
        "https://drive.google.com/drive/folders/1czBklIuUCjYdymMWfUaY_xxuW4QEuuOk";
      window.open(url, "_blank");
    },
  },
  {
    path: "/enedis-losses",
    name: "enedis-losses",
    beforeEnter() {
      const url =
        "https://enedis-losses.innovent.fr/";
      window.open(url, "_blank");
    },
  },
];

var router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (token && !store.getters.token) {
    store.commit("auth_update_token", token);
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (to.matched.some((record) => record.meta.requiresStaff)) {
        if (store.getters.isUserFromStaff) {
          next();
          return;
        } else {
          store.dispatch(
            "snackbar/showError",
            "access denied",
            //this.$filters.capitalize(this.$t("error.forbidden")),
          );
          return;
        }
      }
      if (to.matched.some((record) => record.meta.requiresSge)) {
        // SGE view: restricted to the allowlisted users (same list as raijin / sge_m2m_api)
        if (isSgeUser(store.state.user)) {
          next();
          return;
        }
        store.dispatch("snackbar/showError", "access denied");
        next(from.name ? false : { name: "home" });
        return;
      }
      next();
      return;
    }
    next({
      path: "/login",
      query: { next: to.path }, // the desired page
    });
  } else {
    next();
  }
});

export default router;
